import Jsona from 'jsona';

import config from '../../config';
import http from '../api/http';
import { userActions } from '../slices/user-slice';
import { fetchUpdatedUserProfile } from './auth-actions';

export const createUser = (userData) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL + config.REACT_APP_USER_CREATE_URI;

  const params = {
    data: {
      type: 'User',
      attributes: {
        ...userData,
        tenant: config.REACT_APP_TENANT,
      },
    },
  };

  const create = http.post(apiBaseUrl, params);

  return (dispatch) => {
    dispatch(
      userActions.setLoading({
        isLoading: true,
        willClearError: true,
      })
    );
    dispatch(userActions.clearCRUD());

    return create.then(
      ({ data }) => {
        const createdUser = new Jsona().deserialize(data);

        dispatch(userActions.setCreatedUser(createdUser));
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Create user failed!';
          }
        }

        console.log('User createUser error: ' + errorMessage);

        dispatch(userActions.setError(errorMessage));
      }
    );
  };
};

export const uploadDocuments = (
  userId,
  documentType,
  documentTitle,
  documentNumber,
  issueDate,
  expiryDate,
  file,
  userStatus,
  callback
) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL +
    config.REACT_APP_DOCUMENT_UPLOAD_URI +
    userId;

  var formData = new FormData();

  formData.append('issueDate', issueDate);
  formData.append('expiryDate', expiryDate);
  formData.append('documentType', documentType);
  formData.append('documentTitle', documentTitle);
  formData.append('documentNumber', documentNumber);

  formData.append('files', file);

  //build form header
  http.interceptors.request.use((config) => {
    config.headers = { 'Content-Type': 'multipart/form-data' };
    return config;
  });

  const request = http.post(apiBaseUrl, formData);

  return (dispatch) => {
    dispatch(
      userActions.setLoading({
        isLoading: true,
        willClearError: true,
      })
    );
    dispatch(userActions.clearCRUD());

    request.then(
      ({ data }) => {
        dispatch(userActions.setDocumentUploaded());
        if (userStatus === 256) {
          dispatch(updateUserStatus(userId, -256));
        } else {
          dispatch(fetchUpdatedUserProfile());
        }

        if (callback) {
          callback();
        }
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Upload document failed!';
          }
        }

        console.log('User uploadDocuments error: ' + errorMessage);

        dispatch(userActions.setError(errorMessage));
      }
    );
  };
};

export function updateUserStatus(userId, status) {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL +
    config.REACT_APP_USERS_ACCOUNT_URI +
    '/' +
    userId;

  const params = {
    data: {
      type: 'User',
      attributes: {
        status,
        noEmailSending: true,
      },
    },
    include: config.REACT_APP_PROFILE_INCLUDE,
  };

  const request = http.patch(apiBaseUrl, params);

  return (dispatch) => {
    request.then(
      ({ data }) => {
        dispatch(fetchUpdatedUserProfile());
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Update user status failed!';
          }
        }

        console.log('User updateUserStatus error: ' + errorMessage);

        dispatch(userActions.setError(errorMessage));
      }
    );
  };
}

export function updateUser(userId, userPayload) {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL +
    config.REACT_APP_USERS_URI +
    '/' +
    userId;

  const params = {
    data: {
      type: 'User',
      attributes: {
        ...userPayload,
      },
    },
    include: config.REACT_APP_PROFILE_INCLUDE,
  };

  const request = http.patch(apiBaseUrl, params);

  return (dispatch) => {
    dispatch(
      userActions.setLoading({
        isLoading: true,
        willClearError: true,
      })
    );
    dispatch(userActions.clearCRUD());

    request.then(
      ({ data }) => {
        dispatch(userActions.setUpdatedUser());
        dispatch(fetchUpdatedUserProfile());
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Update user failed!';
          }
        }

        console.log('User updateUser error: ' + errorMessage);

        dispatch(userActions.setError(errorMessage));
      }
    );
  };
}

export const setCreatedUser = () => {
  return (dispatch) => {
    dispatch(userActions.setCreatedUser());
  };
};

export const resetUserCRUD = () => {
  return (dispatch) => {
    dispatch(userActions.clearCRUD());
  };
};

export const resetUserError = () => {
  return (dispatch) => {
    dispatch(userActions.clearError());
  };
};

export const resetUser = () => {
  return (dispatch) => {
    dispatch(userActions.clearUser());
  };
};
